// eslint-disable-next-line import/prefer-default-export
export const OFFER_PAGE_ERROR_MESSAGES = {
  EMAIL_IS_REQUIRED: 'Введите электронную почту',
};
